import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static values = {
    streamUrl: String,
  }

  connect() {
    this.boundVisibilityHandler = this.handleVisibilityChange.bind(this)
    document.addEventListener('visibilitychange', this.boundVisibilityHandler)

    // Initial sync on page load
    this.refreshUpcomingMeetings()
  }

  disconnect() {
    document.removeEventListener(
      'visibilitychange',
      this.boundVisibilityHandler,
    )
  }

  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.refreshUpcomingMeetings()
    }
  }

  async refreshUpcomingMeetings() {
    if (!this.hasStreamUrlValue) return

    const now = Date.now()
    if (this.lastRefreshAt && now - this.lastRefreshAt < 1000) return
    this.lastRefreshAt = now

    try {
      const response = await fetch(this.streamUrlValue, {
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
      })

      if (!response.ok) {
        throw new Error(`Failed: ${response.status}`)
      }

      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error(error)
    }
  }
}
